import MuiDialogContent, {
  DialogContentProps as MuiDialogContentProps
} from '@mui/material/DialogContent';
import React from 'react';

const _dialogContentPaddingVariant = {
  default: undefined,
  none: '0'
};

export interface DialogContentProps extends MuiDialogContentProps {
  padding?: keyof typeof _dialogContentPaddingVariant;
}

/** Extension of Material-UI DialogContent [Api](https://material-ui.com/api/dialog-content/#dialogcontent-api)
 *
 * Body content for a dialog, defaults dividers to true
 */
export function DialogContent({
  dividers,
  padding = 'default',
  ...otherProps
}: DialogContentProps) {
  return (
    <MuiDialogContent
      data-cy="dialogContent"
      dividers
      sx={{ padding: padding === 'none' ? 0 : undefined }}
      {...otherProps}
    />
  );
}
